import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';
import { cn } from '@/lib/utils';

/**
 * Sober DS (v2) — Switch. Radix root + thumb, sober-* tokens only.
 * 44x24 track, muted at rest, primary when checked; 20px white thumb slides
 * ~18px (no colored border — emphasis comes from the track fill + focus ring).
 */
export type SwitchProps = React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root>;

export const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  SwitchProps
>(({ className, ...props }, ref) => (
  <SwitchPrimitive.Root
    ref={ref}
    className={cn(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-sober-border bg-sober-muted',
      'transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sober-primary-fg',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'data-[state=checked]:bg-sober-primary-fg',
      className
    )}
    {...props}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        'pointer-events-none block h-5 w-5 rounded-full bg-white shadow-so-card',
        'transition-transform translate-x-0.5 data-[state=checked]:translate-x-[22px]'
      )}
    />
  </SwitchPrimitive.Root>
));
Switch.displayName = 'Switch';
